/**
 *
 * @param elem - элемент DOM-дерева, видимость которого нужно проверить
 * @param full {bollean} - при true: если элемент частично будет не во вьюпорте, функция будет возвращать false
 * @returns {boolean} - true - если элемент находится в области видимости
 */
export default function checkNodeVisibilityInViewPort (elem, full) {
  if (!elem) return false
  const box = elem.getBoundingClientRect()
  const top = box.top
  const left = box.left
  const bottom = box.bottom
  const right = box.right
  const windowWidth = document.documentElement.clientWidth
  const windowHeight = document.documentElement.clientHeight
  let maxWidth = 0
  let maxHeight = 0
  if (full) {
    maxWidth = right - left
    maxHeight = bottom - top
  }
  return (
    Math.min(windowHeight, bottom) - Math.max(0, top) >= maxHeight &&
    Math.min(windowWidth, right) - Math.max(0, left) >= maxWidth
  )
}
